var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJumpers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 386,
    height: 45,
    viewBox: "0 0 386 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M371 16H11V19H371V16Z",
    fill: "#F1805E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M371 31H11V34H371V31Z",
    fill: "#F1805E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M371 21H11V24H371V21Z",
    fill: "#4A3A80"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M371 36H11V39H371V36Z",
    fill: "#4A3A80"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M371 26H11V29H371V26Z",
    fill: "#66C67F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M371 41H11V44H371V41Z",
    fill: "#66C67F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15H4V20H15V15Z",
    fill: "#234A30"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15 30H4V35H15V30Z",
    fill: "#234A30"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20H4V25H15V20Z",
    fill: "#234A30"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15 35H4V40H15V35Z",
    fill: "#234A30"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M15 25H4V30H15V25Z",
    fill: "#234A30"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15 40H4V45H15V40Z",
    fill: "#234A30"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M371 20H382V15L371 15V20Z",
    fill: "#234A30"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M371 35H382V30H371V35Z",
    fill: "#234A30"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M371 25H382V20H371V25Z",
    fill: "#234A30"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M371 40H382V35H371V40Z",
    fill: "#234A30"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M371 30H382V25H371V30Z",
    fill: "#234A30"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M371 45H382V40H371V45Z",
    fill: "#234A30"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5 17H0V18H5V17Z",
    fill: "#234A30"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M5 32H0V33H5V32Z",
    fill: "#234A30"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M5 22H0V23H5V22Z",
    fill: "#234A30"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M5 37H0V38H5V37Z",
    fill: "#234A30"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M5 27H0V28H5V27Z",
    fill: "#234A30"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M5 42H0V43H5V42Z",
    fill: "#234A30"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M381 18H386V17H381V18Z",
    fill: "#234A30"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M381 33H386V32H381V33Z",
    fill: "#234A30"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M381 23H386V22H381V23Z",
    fill: "#234A30"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M381 38H386V37H381V38Z",
    fill: "#234A30"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M381 28H386V27H381V28Z",
    fill: "#234A30"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M381 43H386V42H381V43Z",
    fill: "#234A30"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M371 1H11V4H371V1Z",
    fill: "#F1805E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M371 6H11V9H371V6Z",
    fill: "#4A3A80"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M371 11H11V14H371V11Z",
    fill: "#66C67F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0H4V5H15V0Z",
    fill: "#234A30"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5H4V10H15V5Z",
    fill: "#234A30"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10H4V15H15V10Z",
    fill: "#234A30"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M371 5L382 5V0L371 0V5Z",
    fill: "#234A30"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M371 10L382 10V5L371 5V10Z",
    fill: "#234A30"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M371 15L382 15V10L371 10V15Z",
    fill: "#234A30"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M5 2H0V3H5V2Z",
    fill: "#234A30"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7H0V8H5V7Z",
    fill: "#234A30"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12H0V13H5V12Z",
    fill: "#234A30"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M381 3L386 3V2L381 2V3Z",
    fill: "#234A30"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M381 8L386 8V7L381 7V8Z",
    fill: "#234A30"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M381 13H386V12H381V13Z",
    fill: "#234A30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJumpers);
export default __webpack_public_path__ + "static/media/jumpers.a35315e98efd73793359412fc1cb6f03.svg";
export { ForwardRef as ReactComponent };